import { IEnvironment } from '@core/interfaces/common';
import packageJSON from '../../package.json';

export const environment: IEnvironment = {
  production: false,
  appName: 'Mi Buzón',
  release: 'Certificación',
  version: packageJSON.version,
  API_KEY: 'MsnG6JIc80euKbGa92mu2gYo_fFav0geqB-wojzVn34',
  BASE_URL: 'https://api.cert.mibuzon.digital.com.do',
  API_CLOUDFRONT: 'https://d1zlmkmglpytrx.cloudfront.net',
  KEY_ENCRYPT: '>!5cHt7w)o.s!)95yuS6"{2>D^Q~Z|C!£=y<rOkoGNRH=*,DE',
};
